import {
  isPixelAccessorWithDimensions,
  type PixelAccessorWithDimensions,
} from "./PixelAccessorWithDimensions";
import type { Viewport } from "./Viewport";

/**
 * ImagePixelAccessor, having virtual viewport.
 */
export interface VirtualViewportPixelAccessor
  extends PixelAccessorWithDimensions {
  /**
   * Returns virtual viewport.
   */
  getViewport(): Viewport;
}

/**
 * Checks if given argument is VirtualViewportPixelAccessor.
 *
 * @param obj
 */
export function isVirtualViewportPixelAccessor(
  obj: unknown
): obj is VirtualViewportPixelAccessor {
  return (
    isPixelAccessorWithDimensions(obj) &&
    typeof (obj as Partial<VirtualViewportPixelAccessor>).getViewport ===
      "function"
  );
}
